import * as z from 'zod';

import { systemUserQueryLinkerSchema } from '@/_pages/system-users/shared';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { aPIKeyQueryLinkerSchema } from './api-key-query-linker-schema';

export const aPIKeyQuerySchema = z.object({
  ...aPIKeyQueryLinkerSchema.shape,
  created_by: systemUserQueryLinkerSchema.nullable(),
  last_updated_by: systemUserQueryLinkerSchema.nullable(),
});

export type APIKeyQuerySchema = z.infer<typeof aPIKeyQuerySchema>;

export const aPIKeyQueryAllSchema = paginatedResponseSchema(aPIKeyQuerySchema);

export type APIKeyQueryAllSchema = z.infer<typeof aPIKeyQueryAllSchema>;
